import { message } from 'ant-design-vue'
function getUrlParams(url?: string): any {
  let _url = url ? url : window.location.href
  _url = _url.split('#')[0] // 对于有hash的情况，去除hash
  let queryString = ''
  queryString = -1 === _url.indexOf('?') ? '' : _url.split('?')[1]
  return getParamDict(queryString)
}
function getParamDict(queryString: string): object {
  let dict: any = {}
  let s = queryString.split('&')
  for (let i = 0; i < s.length; i += 1) {
    let t = s[i].split('=')
    dict[decodeURIComponent(t[0])] = decodeURIComponent(t[1])
  }
  return dict
}

function msgTip(params: { type: any; msg: string }) {
  let { type, msg } = params
  let fun = message[type]
  fun(msg)
}
function getCookie(cookie_name) {
  let allcookies = document.cookie
  let cookie_pos = allcookies.indexOf(cookie_name)
  let value = ''
  if (cookie_pos != -1) {
    cookie_pos = cookie_pos + cookie_name.length + 1
    let cookie_end = allcookies.indexOf(';', cookie_pos)

    if (cookie_end == -1) {
      cookie_end = allcookies.length
    }
    value = unescape(allcookies.substring(cookie_pos, cookie_end))
  }
  return value
}

// 判断两个对象内容是否一致
function isObjectValueEqual(a, b) {
  let aProps = Object.getOwnPropertyNames(a)
  let bProps = Object.getOwnPropertyNames(b)

  if (aProps.length != bProps.length) {
    return false
  }

  for (let i = 0; i < aProps.length; i++) {
    let propName = aProps[i]
    if (a[propName] !== b[propName]) {
      return false
    }
  }

  return true
}
function myBrowser() {
  let userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
  let isOpera = userAgent.indexOf('Opera') > -1
  if (isOpera) {
    return 'Opera'
  } // 判断是否Opera浏览器
  if (userAgent.indexOf('Firefox') > -1) {
    return 'FF'
  } // 判断是否Firefox浏览器
  if (userAgent.indexOf('Chrome') > -1) {
    return 'Chrome'
  }
  if (userAgent.indexOf('Safari') > -1) {
    return 'Safari'
  } // 判断是否Safari浏览器
  if (userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera) {
    return 'IE'
  } // 判断是否IE浏览器
}
// 判断操作系统
function myOS() {
  let agent = navigator.userAgent.toLowerCase()
  let isMac = /macintosh|mac os x/i.test(navigator.userAgent)

  if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
    return 'win32'
  }
  if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
    return 'win64'
  }
  if (isMac) {
    return 'osx'
  }
}
export { msgTip, getUrlParams, getParamDict, getCookie, isObjectValueEqual, myBrowser, myOS }
